/** Reuses the initialized Zendesk App Framework client across the app's views and data loaders. */
export const zendesk = ZAFClient.init();
